module.exports = __webpack_public_path__ + "static/media/synopsis-correlations-and-automated-charting-03.52847c12.png";